import { Snackbar, Alert, AlertTitle } from '@mui/material';
import { formatMessage } from 'src/i18n/intl';
import Locale from 'src/i18n';

const DownloadSuccessAlert = ({ handleTemplateDownloadSuccess }) => {
    return (
        <Snackbar
            open
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            autoHideDuration={5000}
            disableWindowBlurListener
            onClose={handleTemplateDownloadSuccess}>
            <div>
                <Alert
                    severity="success"
                    contrast="normal"
                    width="toast"
                    onClose={handleTemplateDownloadSuccess}
                    title={formatMessage(Locale.success)}>
                    <AlertTitle>{formatMessage(Locale.success)}</AlertTitle>
                    {formatMessage(Locale.templateDownloadSuccessMessage)}
                </Alert>
            </div>
        </Snackbar>
    );
};

export default DownloadSuccessAlert;
